import { FC } from "react";

import {
  StyledPermissionFieldGroup,
  StyledPermissionFieldGroupProps,
} from "./styles";

interface PermissionFieldGroupProps extends StyledPermissionFieldGroupProps {}

export const PermissionFieldGroup: FC<PermissionFieldGroupProps> = ({
  children,
  ...rest
}) => {
  return (
    <StyledPermissionFieldGroup {...rest}>
      {children}
    </StyledPermissionFieldGroup>
  );
};
